<template>
    <el-dialog title="小程序二维码" :visible.sync="dialogVisible" append-to-body>

        <a :href="src" download="二维码" target="_blank" title="右键下载">
            <el-image v-if="src" :src="src" class="image"></el-image>
            <div style="text-align: center;">点击下载 或 右键下载图片</div>
        </a>

        <span slot="footer" class="dialog-footer">
            <!-- <el-button @click="handleCloseDialog">取 消</el-button> -->
            <el-button type="primary" @click="handleCloseDialog">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
    import { getMiniAppQrcode } from '@/api/huodongguanliBaomingjilu'

    export default {
        data() {
            return {
                dialogVisible: false,

                query: {
                    // token: sessionStorage.getItem("token"),
                    // id: '',
                    path: 'pages/h5/h5',
                    env: 'release',
                    scene: ''
                },
                src: ''
            }
        },
        created() {},
        methods: {
            handleOpenDialog(row) {
                this.query.scene = `id=${row.id}&isForm=erweima&index=10`
                this.getDetail();
                this.dialogVisible = true;
            },
            handleCloseDialog() {
                this.dialogVisible = false;
            },

            getDetail() {
                getMiniAppQrcode(this.query).then(({ data: res }) => {
                    this.src = res.data.url;
                })
            },
        }
    }
</script>

<style lang="less" scope>
    .image {
        display: block;
        width: 500px;
        height: 500px;
        margin: 0 auto;
    }
</style>